import React from 'react'

import * as S from '../styles'

interface SuccessProps {
  children: JSX.Element | string
}

export const Success = ({ children }: SuccessProps): JSX.Element => {
  return (
    <>
      <S.StyledCheckIcon />
      <S.Title data-cy='request-treatment-success'>
        {children}
      </S.Title>
    </>
  )
}